exports.onRouteUpdate = function onRouteUpdate({ location }) {
  if (typeof window === "undefined") return;

  // Skip ads and Disqus on admin pages
  if (location.pathname.startsWith("/admin")) return;

  // Attempt to (re)fill any ad slots after client-side navigation
  try {
    // eslint-disable-next-line no-underscore-dangle
    const adsbygoogle = window.adsbygoogle || [];
    const adElements = document.querySelectorAll(
      "ins.adsbygoogle:not([data-adsbygoogle-status])"
    );
    if (adElements.length > 0) {
      adElements.forEach(() => adsbygoogle.push({}));
    } else {
      // For Auto ads, nudge AdSense to reevaluate on SPA route changes
      adsbygoogle.push({});
    }
  } catch (err) {
    // no-op
  }

  // Reset Disqus on route change for SPA navigation
  if (window.DISQUS && window.DISQUS.reset) {
    try {
      window.DISQUS.reset({
        reload: true,
      });
    } catch (err) {
      // no-op
    }
  }
};

// Handle Netlify Identity login redirect
exports.onInitialClientRender = function onInitialClientRender() {
  if (typeof window !== "undefined" && window.netlifyIdentity) {
    window.netlifyIdentity.on("init", (user) => {
      if (!user) {
        window.netlifyIdentity.on("login", () => {
          document.location.href = "/admin/";
        });
      }
    });
  }
};
